// extracted by mini-css-extract-plugin
export default {"mobile_nav_wrapper":"Sn","mobile_nav":"Tn","link":"Un","link_name":"Vn","active":"Wn"};
    if(module.hot) {
      // 1738064236108
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  